const elemRT = document.querySelectorAll('.wt-Ratings');

window.fireOnVisible(elemRT, async() => {
    await import('./assets/css/wt-Ratings.scss');
    await import('./assets/css/swt-Rating_Provider.scss');

    if (window.TCMS.product === 'urlaub') {
        await import('./assets/js/urlaubRatings.ts');
    } else {
        const { BeaconRating } = await import('./assets/js/ratings.ts');
        const ck24_beaconRating = new BeaconRating();

        ck24_beaconRating.initialize();
    }

    const ratingMw = document.querySelectorAll('.swt-Rating_Provider.mw');

    if (ratingMw.length > 0) {
        await import('./assets/css/swt-Rating_Carrenter.scss');
        await import('./assets/css/ck24_aditionalInfo.scss');
        await import('./assets/css/swt-Rating_accordion.scss');

        for (const ratingMwEntry of ratingMw) {
            if (ratingMwEntry.classList.contains('destination')) {
                await import('./assets/css/swt-rating_destination_carrenter.scss');
                break; // End for loop because one time is enough
            }
        }
    }
});
